export const rolEnum = {
	Administrador: 1,
	Supervisor: 2,
	Auditor: 3,
	Cliente: 4,
};

export const statusEnum = {
	EN_ESPERA: null,
	APROBADO: 2,
	RECHAZADO: 3,
	PROCESO: 4,
};
